(function () {
	'use strict';

	if (!document.querySelector('.uvindex')) {
		return;
	}

	const selectElement = document.getElementById('locations');
	const continentSelect = document.getElementById('continents');

	function renderUVIndex(dataArray) {
		const container = document.getElementById('weeklyUvIndex');
		container.innerHTML = '';

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const futureDays = dataArray.filter((data) => {
			const dataDate = new Date(data.date);
			dataDate.setHours(0, 0, 0, 0);

			return dataDate > today;
		});

		futureDays.forEach((data, index) => {
			const item = document.createElement('div');

			const time = new Date(data.maxUvIndexTime);
			const formattedTime =
				time.getHours().toString().padStart(2, '0') + ':' + time.getMinutes().toString().padStart(2, '0');

			const formattedMaxUv = parseFloat(data.maxUvIndex).toFixed(1).replace('.', ',');

			item.className = 'uv-index-item';
			if (index % 2 === 0) {
				item.classList.add('alternate-background');
			}
			item.innerHTML = `
	        <h4>${data.dateLabel}</h4>
	        <p>Max UV-index: ${formattedMaxUv}</p>
	        <p>Solen är som starkast klockan ${formattedTime}</p>
	    `;
			container.appendChild(item);
		});
	}

	function renderUVIndexToday(todaysData, locationLabel) {
		const container = document.getElementById('todaysUvIndex');
		container.innerHTML = '';

		if (todaysData) {
			const time = new Date(todaysData.maxUvIndexTime);
			const formattedTime =
				time.getHours().toString().padStart(2, '0') + ':' + time.getMinutes().toString().padStart(2, '0');
			const formattedMaxUv = parseFloat(todaysData.maxUvIndex).toFixed(1).replace('.', ',');

			const paragraph = document.createElement('p');
			paragraph.innerHTML = `Solen ${
				'i ' + locationLabel || 'på denna plats'
				} idag är som starkast klockan ${formattedTime} lokal tid. UV-index beräknas då vara ${formattedMaxUv}. Prognosen gäller vid klart väder.`;
			container.appendChild(paragraph);
		} else {
			const paragraph = document.createElement('p');
			paragraph.innerHTML = 'Kunde inte hämta dagens data.';
			container.appendChild(paragraph);
		}
	}

	function positionMarker(uvIndexValue) {
		const maxUVIndex = 11;
		const marker = document.querySelector('.uvindex-marker');
		if (marker) {
			const positionPercent = (uvIndexValue / maxUVIndex) * 100;
			marker.style.left = `calc(${positionPercent}% - ${marker.offsetWidth / 2}px)`;
		}
	}

	function setCurrentUvDescription(uvIndexValue) {
		const textContainer = document.getElementById('uvindex-current-description');
		const haveUvValue = uvIndexValue || uvIndexValue === 0;
		let description = haveUvValue ? '' : 'Kunde inte hämta data';
		uvIndexValue = Math.round(uvIndexValue);

		if (!haveUvValue) {
			return;
		} else if (uvIndexValue >= 0 && uvIndexValue < 3) {
			description += 'Lågt (1-2)';
		} else if (uvIndexValue >= 3 && uvIndexValue < 6) {
			description += 'Medelhögt (3-5)';
		} else if (uvIndexValue >= 6 && uvIndexValue < 8) {
			description += 'Högt (6-7)';
		} else if (uvIndexValue >= 8 && uvIndexValue < 11) {
			description += 'Mycket högt (8-10)';
		} else if (uvIndexValue >= 11) {
			description += 'Extremt (11 eller högre)';
		}

		textContainer.textContent = description;
	}

	function setLocalTime(localTime) {
		const container = document.getElementById('uvindex-local-time');
		container.textContent = '';

		if (localTime) {
			const hours = localTime.getHours().toString().padStart(2, '0');
			const minutes = localTime.getMinutes().toString().padStart(2, '0');
			const formattedTime = `${hours}:${minutes}`;
			container.textContent = `Lokal tid: ${formattedTime}`;
		}
	}

	function setTimeFetched(dateString) {
		const container = document.getElementById('uvindex-data-fetched-date');
		container.textContent = '';

		if (dateString) {
			const date = new Date(dateString + 'Z');

			const day = date.getUTCDate().toString().padStart(2, '0');
			const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
			const year = date.getUTCFullYear();
			const hours = date.getUTCHours().toString().padStart(2, '0');
			const minutes = date.getUTCMinutes().toString().padStart(2, '0');

			const formattedDate = `${day}/${month}/${year} kl ${hours}:${minutes}`;
			container.textContent = formattedDate;
		}
	}

	function updateCurrentUVIndexAndMarker(hourlyUVData, localTime) {
		const currentHour = localTime.getHours();
		const currentUVIndex = hourlyUVData[currentHour];

		const uvIndexDisplay = document.querySelector('.uvindex-block-current-index');
		uvIndexDisplay.textContent = '?';
		setCurrentUvDescription(currentUVIndex);

		if (currentUVIndex || currentUVIndex === 0) {
			uvIndexDisplay.textContent = Math.round(currentUVIndex);
			const cappedUVIndex = Math.min(currentUVIndex, 11);
			positionMarker(cappedUVIndex);
		}
	}

	function fetchDataForLocation(locationName, offset) {
		const apiUrl = `/api/uvindex/${encodeURIComponent(locationName)}?offset=${encodeURIComponent(offset)}`;
		return fetch(apiUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				return data.response;
			})
			.catch((error) => {
				console.error('There has been a problem fetching location data for location: ', error);
				return [];
			});
	}

	function fetchLocations() {
		if (fetchLocations.locations) {
			return new Promise((resolve) => {
				resolve(fetchLocations.locations);
			});
		}

		const apiUrl = `/api/uvindex/locations`;
		return fetch(apiUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				fetchLocations.locations = data.response;
				return data.response;
			})
			.catch((error) => {
				console.error('There has been a problem fetching location data:', error);
				return [];
			});
	}

	function fetchAndFormatDataForLocation(data) {
		return data.map((dp) => ({
			...dp,
			dateLabel: formatLegendDate(dp.date),
		}));
	}

	function formatLegendDate(dateString) {
		const today = new Date();
		const date = new Date(dateString);

		const todayComparisonFormat = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		const dateComparisonFormat = new Date(date.getFullYear(), date.getMonth(), date.getDate());

		if (dateComparisonFormat.getTime() === todayComparisonFormat.getTime()) {
			return 'Idag';
		} else {
			const weekday = new Intl.DateTimeFormat('sv-SE', { weekday: 'long' }).format(date);
			const day = date.getDate();
			const month = new Intl.DateTimeFormat('sv-SE', { month: 'short' }).format(date).slice(0, 3);

			const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
			const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

			return `${capitalizedWeekday} ${day} ${capitalizedMonth}`;
		}
	}

	function getTodaysData(dataArray) {
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const todaysData = dataArray.find((data) => {
			const dataDate = new Date(data.date);
			dataDate.setHours(0, 0, 0, 0);
			return dataDate.getTime() === today.getTime();
		});
		return todaysData;
	}

	function getTimeZone(latitude, longitude) {
		return GeoTZ.find(latitude, longitude);
	}

	function getLocalTime(latitude, longitude) {
		const now = new Date();
		return getTimeZone(latitude, longitude).then((timezone) => {
			const formatter = new Intl.DateTimeFormat('en-US', {
				timeZone: timezone[0],
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
				timeZoneName: 'shortOffset',
			});

			let offset = formatter
				.formatToParts()
				.find((part) => part.type === 'timeZoneName')
				.value.replace('GMT', '');
			offset = offset.split(':')[0];
			offset = offset.trim() !== '' ? -Number(offset.trim()) : 0;

			const formattedDateTime = formatter.format(now);

			const dateTimeParts = formattedDateTime.match(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2})/);
			if (!dateTimeParts) {
				throw new Error('DateTime format mismatch or parsing error');
			}
			const [, month, day, year, hour, minute] = dateTimeParts.map((num) => parseInt(num, 10));

			return [new Date(year, month - 1, day, hour, minute), offset];
		});
	}

	function populateLocationsDropdown(locationArray) {
		const selectElement = document.getElementById('locations');
		selectElement.innerHTML = '';

		if (!locationArray || locationArray.length === 0) {
			return;
		}
	
		// Sort alphabetically by location name (Swedish locale)
		const sortedLocations = locationArray.slice().sort((a, b) =>
			a.location.localeCompare(b.location, 'sv-SE')
		);
	
		sortedLocations.forEach(({ location }) => {
			const option = document.createElement('option');
			option.value = location;
			option.textContent = location;
			selectElement.appendChild(option);
		});
	}

	fetchLocations().then((uvIndexLocations) => {
		const continents = Array.from(
			new Set(uvIndexLocations.map(loc => loc.continent))
		);
		
		// Sort A-Ö
		continents.sort((a, b) => a.localeCompare(b, 'sv-SE'));
	  
		// Stick Sverige on top
		const uniqueContinents = ['Sverige', ...continents];

		uniqueContinents.forEach((continent) => {
			const option = document.createElement('option');
			option.value = continent;
			option.textContent = continent;
			continentSelect.appendChild(option);
		});

		// const defaultContinent = uniqueContinents.includes('Europa') ? 'Europa' : uvIndexLocations[0].continent;
		const defaultContinent = 'Sverige';
		continentSelect.value = defaultContinent;

		const filtered = uvIndexLocations.filter((loc) => loc.location.includes('Sverige'));
		// const filtered = uvIndexLocations.filter((loc) => loc.continent === defaultContinent); Use if default is changed to a continent
		populateLocationsDropdown(filtered);
	});

	function initializeOrUpdateChart(newData) {
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const dataWithoutPassedDays = newData.filter((data) => {
			const dataDate = new Date(data.date);
			dataDate.setHours(0, 0, 0, 0);

			return dataDate >= today;
		});

		if (!window.myChart) {
			window.myChart = window.createChart(dataWithoutPassedDays);
		} else {
			window.updateChart(window.myChart, dataWithoutPassedDays);
		}
	}

	continentSelect.addEventListener('change', function () {
		fetchLocations().then((uvIndexLocations) => {
			let filtered = [];
			selectElement.innerHTML = '';

			if (this.value === 'Sverige') {
				filtered = uvIndexLocations.filter((loc) => loc.location.includes('Sverige'));
			} else {
				const selectedContinent = uvIndexLocations.find(({ continent }) => continent == this.value).continent;
				continentSelect.value = selectedContinent;
				filtered = uvIndexLocations.filter((loc) => loc.continent === selectedContinent);
			}

			populateLocationsDropdown(filtered);

			selectElement.selectedIndex = 0;
			selectElement.dispatchEvent(new Event('change'));
		});
	});

	selectElement.addEventListener('change', function () {
		fetchLocations().then((uvIndexLocations) => {
			const selectedLocation = uvIndexLocations.find(({ location }) => location == this.value);
			selectElement.value = selectedLocation.location;

			const { latitude, longitude } = selectedLocation;
			getLocalTime(latitude, longitude).then(([localTime, offset]) => {
				fetchDataForLocation(selectedLocation.location, offset).then((result) => {
					const data = result.location.date;
					const chartData = fetchAndFormatDataForLocation(data);
					initializeOrUpdateChart(chartData);
					renderUVIndex(chartData);

					const todaysData = getTodaysData(chartData);
					renderUVIndexToday(todaysData, result.location.name);
					updateCurrentUVIndexAndMarker(todaysData.hourlyUvIndex, localTime);
					setLocalTime(localTime);
					setTimeFetched(result.collectedAt);
				});
			});
		});
	});

	window.addEventListener('load', () => {
		fetchLocations().then((uvIndexLocations) => {
			const defaultLocation =
				uvIndexLocations.find(({ location }) => location == 'Sverige (Stockholm)') || uvIndexLocations[0];

			selectElement.value = defaultLocation.location;
			const { latitude, longitude } = defaultLocation;
			getLocalTime(latitude, longitude).then(([localTime, offset]) => {
				fetchDataForLocation(defaultLocation.location, offset).then((result) => {
					const data = result.location.date;
					const chartData = fetchAndFormatDataForLocation(data);
					initializeOrUpdateChart(chartData);
					renderUVIndex(chartData);

					const todaysData = getTodaysData(chartData);
					renderUVIndexToday(todaysData, result.location.name);
					updateCurrentUVIndexAndMarker(todaysData.hourlyUvIndex, localTime);
					setLocalTime(localTime);
					setTimeFetched(result.collectedAt);
				});
			});
		});
	});
})();
